// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AttachmentSvg from '../icons/file/Attachment';
var Attachment = createSvgIcon({
    as: AttachmentSvg,
    ariaLabel: 'attachment',
    category: 'file',
    displayName: 'Attachment'
});
export default Attachment;
